import { Checkbox } from '../../components/inputs/Checkbox'
import { TextInput } from '../../components/inputs/textInput'

type AgeRange = { min?: number; max?: number }
export function AudienceFields({
  contentLabel = 'good list',
  ageRange,
  genders,
  onAgeChange,
  onGendersChange,
}: {
  contentLabel?: string
  ageRange?: AgeRange | null
  genders: string[]
  onAgeChange: (range: AgeRange) => void
  onGendersChange: (genders: string[]) => void
}) {
  return (
    <div className="space-y-4 py-4">
      <h2 className="font-medium">Age and gender matching</h2>
      <p className="text-sm text-sec-black">
        Help this {contentLabel} reach customers it suits. Leave fields empty
        for everyone. These preferences affect recommendations, not access.
      </p>
      <div className="grid grid-cols-2 gap-4">
        <TextInput
          title="Minimum age"
          aria-label="Minimum age"
          hasIcon={false}
          type="number"
          min={0}
          max={ageRange?.max ?? 120}
          step={1}
          value={ageRange?.min === undefined ? '' : String(ageRange.min)}
          onChange={(event) =>
            onAgeChange({
              ...ageRange,
              min:
                event.target.value === ''
                  ? undefined
                  : Number(event.target.value),
            })
          }
        />
        <TextInput
          title="Maximum age"
          aria-label="Maximum age"
          hasIcon={false}
          type="number"
          min={ageRange?.min ?? 0}
          max={120}
          step={1}
          value={ageRange?.max === undefined ? '' : String(ageRange.max)}
          onChange={(event) =>
            onAgeChange({
              ...ageRange,
              max:
                event.target.value === ''
                  ? undefined
                  : Number(event.target.value),
            })
          }
        />
      </div>
      <p className="text-sm font-medium">Gender (optional)</p>
      {[
        { value: 'MALE', label: 'Male' },
        { value: 'FEMALE', label: 'Female' },
      ].map(({ value, label }) => (
        <Checkbox
          key={value}
          text={label}
          checkStatus={genders.includes(value)}
          handleChange={(checked) =>
            onGendersChange(
              checked
                ? [...genders, value]
                : genders.filter((gender) => gender !== value),
            )
          }
        />
      ))}
      <p className="text-sm text-sec-black">
        Customers who haven’t shared their age or gender can still see this{' '}
        {contentLabel}.
      </p>
    </div>
  )
}
